<script lang="ts">
    import { LOGO_WIDTH_M, LOGO_WIDTH_L } from '$lib/components/constants';

    import { cn } from '$lib/utils/cn';

    import type { LogoSize } from '$lib/types/Components/Logos/LogosContent';

    export let images: string[] = [];
    export let isGrayscale = false;
    export let size: LogoSize = 'medium';
    export let logoGapXPx: number | undefined = undefined;

    const derivedLogoWidth = size === 'medium' ? LOGO_WIDTH_M : LOGO_WIDTH_L;

    $: innerClass = cn(
        'fun-flex fun-items-center fun-justify-center',
        logoGapXPx === undefined && 'fun-px-6',
        {
            'fun-h-6': size === 'medium',
            'fun-h-9': size === 'large',
        },
    );

    const getOptimizedSrc = (src: string): string => {
        if (!src.includes('imgix.net') && !src.includes('unsplash.com')) {
            return src;
        }

        try {
            const url = new URL(src);

            if (url.searchParams.has('w') || url.searchParams.has('h')) {
                return src;
            }

            url.searchParams.set('w', String(derivedLogoWidth));
            url.searchParams.set('dpr', '2');
            url.searchParams.set('fit', 'clip');
            url.searchParams.set('auto', 'format,compress');

            return url.toString();
        } catch {
            return src;
        }
    };
</script>

{#each images as image, index (`${image}-${index}`)}
    <div style:padding-inline={logoGapXPx !== undefined ? `${logoGapXPx}px` : undefined}>
        <div class={innerClass} style:width={`${derivedLogoWidth}px`}>
            <div class="fun-relative fun-size-full">
                <img
                    src={getOptimizedSrc(image)}
                    alt={`Logo #${index}`}
                    class={cn('fun-mx-auto fun-h-full fun-object-contain', {
                        'fun-grayscale': isGrayscale,
                    })}
                    aria-hidden="true"
                />
            </div>
        </div>
    </div>
{/each}
